import { AvLibraryListWithSearch } from '@verantos-dev/feature-cohort-builder';
import { ApiWorkflowDialog } from '@verantos-dev/shared-components';

import { useAddVariablePickerModal } from '../../hooks/useAddVariablePickerModal';
import type { AddVariablePickerModalProps } from '../../types';

// Module-scope for prop-reference stability; AD has no name-collision concept.
const NO_NAME_CONFLICTS = new Set<string>();

export const AddVariablePickerModal = ({ projectId, onClose }: AddVariablePickerModalProps) => {
  const {
    title,
    items,
    searchQuery,
    onSearchChange,
    onSelectAv,
    onSelectAll,
    isSelected,
    alreadyAddedAvIds,
    isLoading,
    isError,
    onConfirm,
    onCancelClose,
    canConfirm,
    dialogMessages,
  } = useAddVariablePickerModal({ projectId, onClose });

  return (
    <ApiWorkflowDialog
      id="addVariablePickerModal"
      title={title}
      dialogMessages={dialogMessages}
      onClose={onCancelClose}
      onSubmit={onConfirm}
      onRetrySubmit={onConfirm}
      isValidForSubmit={canConfirm}
      isSubmitting={false}
      size="medium"
    >
      <AvLibraryListWithSearch
        searchQuery={searchQuery}
        onSearchChange={onSearchChange}
        items={items}
        isLoading={isLoading}
        isError={isError}
        multiple
        onSelect={onSelectAv}
        onSelectAll={onSelectAll}
        isSelected={isSelected}
        inCohortAvIds={alreadyAddedAvIds}
        nameConflictAvIds={NO_NAME_CONFLICTS}
        searchInputTestId="add-variable-picker-search"
      />
    </ApiWorkflowDialog>
  );
};
